import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { TenantLogo } from '@/components/tenant-logo'
import { useI18n } from '@/i18n/i18n-react'
import { Button } from '@/components/ui/button'
import { tenant } from '@/tenants/tenant'
import { hasAccountLogin } from '@/utils/tester-mode'
import { z } from 'zod'

export const Route = createFileRoute('/onboarding/welcome')({
	validateSearch: z.object({ redirect: z.string().optional() }),
	component: WelcomeScreen
})

function WelcomeScreen() {
	const { L } = useI18n()
	const navigate = useNavigate()
	const { features } = tenant
	const { redirect } = Route.useSearch()

	const handleGetStarted = () => {
		if (hasAccountLogin()) {
			navigate({ to: '/onboarding/login', search: { redirect } })
		} else {
			navigate({ to: '/onboarding/intro', search: { redirect } })
		}
	}

	return (
		<div className='bg-primary flex min-h-dvh flex-col'>
			<div className='flex flex-1 flex-col items-center justify-center gap-8 px-6 py-12'>
				{/* Logo circle — only shown when the tenant provides a small logo */}
				{tenant.logoSmall && (
					<div className='bg-primary-foreground/20 flex h-36 w-36 items-center justify-center rounded-full'>
						<TenantLogo asset={tenant.logoSmall} className='text-primary h-20 w-20' />
					</div>
				)}

				<div className='flex flex-col items-center gap-4 text-center'>
					<h1 className='text-primary-foreground text-3xl font-bold'>
						{L.Onboarding.WelcomeTitle({ name: features.name })}
					</h1>
					<p className='text-primary-foreground/80 text-lg'>{L.Onboarding.WelcomeMessage()}</p>
				</div>
			</div>

			<div className='p-6'>
				<Button
					className='bg-primary-foreground text-primary hover:bg-primary-foreground/90 w-full'
					size='lg'
					onClick={handleGetStarted}
				>
					{L.Onboarding.GetStarted()}
				</Button>
			</div>
		</div>
	)
}
